export default "__VITE_ASSET__CQU$Rpoo__"